/**
 *
 */
type VideoGallery = {
	videoColumns: HTMLElement[],
	loadMoreBtn?: HTMLButtonElement,
	currentPage: number,
	maxVideosPerPage: number,
};


const videoGalleries: VideoGallery[] = [];


/**
 *
 */
const setupVideoGalleries = () =>
{
	const galleries = document.querySelectorAll( '.section-video-gallery' );

	galleries.forEach( gallery =>
	{
		const tabPanes         = gallery.querySelectorAll( '.tab-pane' );
		const maxVideosPerPage = gallery.classList.contains( 'layout-full' ) ? 3 : 6;

		tabPanes.forEach( tabPane =>
		{
			const videoColumns               = tabPane.querySelectorAll( '[data-video-column]' );
			const loadMoreBtn                = tabPane.querySelector( '[data-load-more]' );
			const videoGallery: VideoGallery = {
				videoColumns:     [],
				currentPage:      0,
				maxVideosPerPage: 2,
			}
			let page                         = 0;

			videoColumns.forEach( ( videoColumn, key ) =>
			{
				if (key > 0 && key % maxVideosPerPage === 0) {
					page++;
				}

				if (videoColumn instanceof HTMLElement) {
					videoColumn.setAttribute( 'data-page', page.toString() );

					videoGallery.videoColumns.push( videoColumn );
				}
			} );

			videoGalleries.push( videoGallery );

			if (loadMoreBtn instanceof HTMLButtonElement) {

				videoGallery.loadMoreBtn = loadMoreBtn;

				loadMoreBtn.addEventListener( 'click', e =>
				{
					e.preventDefault();

					videoGallery.currentPage++;
					draw();
				} );
			}
		} );
	} );

	draw();
};


/**
 *
 */
const draw = () =>
{
	videoGalleries.forEach( videoGallery =>
	{
		let allShowing = true;

		videoGallery.videoColumns.forEach( videoColumn =>
		{
			const page = parseInt( videoColumn.dataset.page || '', 10 );

			if (page <= videoGallery.currentPage) {
				videoColumn.classList.remove( 'no-display' );
			} else {
				videoColumn.classList.add( 'no-display' );
				allShowing = false;
			}
		} );

		if (videoGallery.loadMoreBtn) {
			if (allShowing) {
				videoGallery.loadMoreBtn.classList.add( 'no-display' );
			} else {
				videoGallery.loadMoreBtn.classList.remove( 'no-display' );
			}
		}
	} );
};


/**
 *
 */
export default setupVideoGalleries;